import { useLocation, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
// @mui
import { Box, Link, Container, Typography, Stack } from '@mui/material';
// components
import useMaintenanceStatus from '../../components/hook-form/useMaintenanceStatus';
import Logo from '../../components/Logo';
import MaintenanceBanner from '../../components/MaintenanceBanner';

import MainFooter from './MainFooter';
import MainHeader from './MainHeader';

// ----------------------------------------------------------------------

export default function MainLayout() {
  const { pathname } = useLocation();
  const { isMaintenance, maintenanceMsg } = useMaintenanceStatus();

  const isHome = pathname === '/';

  return (
    <div className="wrapper" id="wrapper">
      <MainHeader />
      <MaintenanceBanner isVisible={isMaintenance} message={maintenanceMsg} />
      <Outlet />
      <MainFooter />
    </div>  
  );
}
